import React, { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { ClipboardPaste } from "lucide-react";
import type { IngestionDraft } from "./types";

interface PasteIngestionTabProps {
  onCapture: (draft: IngestionDraft) => void;
}

const PasteIngestionTab = ({ onCapture }: PasteIngestionTabProps) => {
  const [text, setText] = useState("");

  const handleCapture = () => {
    if (!text.trim()) return;

    const draft: IngestionDraft = {
      source: {
        source_type: "paste",
        content: text.trim(),
        timestamp: new Date().toISOString(),
      },
      raw_content: text.trim(),
      status: "captured",
      data_type: null,
      structured_extraction: null,
      ai_notes: null,
    };

    onCapture(draft);
    setText("");
  };

  return (
    <div className="flex flex-col gap-3">
      <Textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Paste activity details here (schedule, location, program info, etc.)"
        className="min-h-[120px] bg-white/10 border-white/20 text-white placeholder:text-white/50 resize-none"
      />
      <Button
        onClick={handleCapture}
        disabled={!text.trim()}
        className="self-end bg-white/20 hover:bg-white/30 text-white"
      >
        <ClipboardPaste className="w-4 h-4 mr-2" />
        Capture
      </Button>
    </div>
  );
};

export default PasteIngestionTab;
